var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9257 22L10.7587 21.9804C5.51484 21.3218 1.68698 16.6857 2.02019 11.3967C2.35341 6.10774 6.73268 1.99157 12.0175 2.00001C17.3024 2.00846 21.6686 6.13859 21.985 11.4286C22.3014 16.7187 18.4588 21.3425 13.2128 21.9843L13.0781 22L12.9824 21.001L13.0918 20.9892C17.8135 20.4129 21.273 16.2521 20.9893 11.4908C20.7056 6.72953 16.7766 3.01143 12.02 3.00298C7.26346 2.99453 3.32137 6.69864 3.02084 11.4589C2.72031 16.2191 6.1651 20.3922 10.8848 20.9853L11.0371 21.003L10.9257 22ZM11.5029 6.9595H12.5029V8.96914H11.5029V6.9595ZM12.5029 9.96574H11.5029V16.9948H12.5029V9.96574Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconBlack);
export default __webpack_public_path__ + "static/media/WarningIconBlack.cb0aa422c049006b6591c67f5e8a78e4.svg";
export { ForwardRef as ReactComponent };